import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { Observable, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/base.component';
import { Constants } from 'src/app/shared/data/constants';
import { ComparatorSummary } from 'src/app/shared/models/franchise/ComparatorSummary';
import { AppStateInterface } from 'src/app/store/appState.interface';
import { invokeCompareLocations } from 'src/app/store/franchise/franchise.action';
import { comparatorResultSelector, loadingFranchiseComparatorSelector } from 'src/app/store/franchise/franchise.selectors';

interface StatsInterface {
  impressions: number;
  consumers: number;
};

type RankMapping = Record<number, Record<number,number>>

const rankMapping: RankMapping = {
  2: {
    0: 0,
    1: 4
  },
  3: {
    0: 0,
    1: 3,
    2: 4
  },
  4: {
    0: 0,
    1: 1,
    2: 3,
    3: 4
  },
  5: {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4
  }
}

@Component({
  selector: 'app-compare-modal',
  templateUrl: './compare-modal.component.html',
  styleUrls: ['./compare-modal.component.scss']
})
export class CompareModalComponent extends BaseComponent implements OnInit {

  @Input() locations: string[];

  loading: boolean | null;
  isLoading$: Observable<boolean | null>;

  dateFilter = {
    endDate: new Date(),
    startDate: new Date(new Date().getTime() - 7 * Constants.oneDay),
  }

  formFilter: FormGroup;
  comparatorResults$: Observable<ComparatorSummary[] | null>;

  locationsStats: Record<string, StatsInterface> = {};

  locationRankingPerImpression: string[] = [];
  locationRankingPerUniqueViews: string[] = [];
  locationRankingPerConsumers: string[] = [];

  constructor(
    private modalService: NgbModal,
    private store: Store<AppStateInterface>,
    private fb: FormBuilder
  ) {
    super(store);
    this.formFilter = this.fb.group({
      date: [[this.dateFilter.startDate, this.dateFilter.endDate]]
    });

    this.comparatorResults$ = this.store
      .pipe(select(comparatorResultSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.isLoading$ = this.store
      .pipe(select(loadingFranchiseComparatorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {

    this.formFilter.valueChanges.subscribe((values) => {
      this.dateFilter = {
        startDate: values.date[0],
        endDate: values.date[1],
      };
    
    this.store.dispatch(invokeCompareLocations({ data: {
      locations: this.locations,
      startDate: this.formFilter.get('date')?.value[0],
      endDate: this.formFilter.get('date')?.value[1]
    } }));
    });

    this.store.dispatch(invokeCompareLocations({ data: {
      locations: this.locations,
      startDate: this.formFilter.get('date')?.value[0],
      endDate: this.formFilter.get('date')?.value[1]
    } }));
    
    // subscribe and fill locationsStats and locationRankingPerCriteria
    this.comparatorResults$.subscribe((result) => {
      if (result?.length) {
        const newLocationStats: Record<string, StatsInterface> = {};;
        result.forEach(({ companyName, impressions, uniqueUsers }) => {
          newLocationStats[companyName] = { impressions, consumers: uniqueUsers };
        });
        this.locationsStats = newLocationStats;

        let mutableResult = [...result];
        this.locationRankingPerImpression = [...(mutableResult.sort((r1, r2) => r2.impressions - r1.impressions).map(({ companyName }) => companyName ))];
        mutableResult = [...result];
        this.locationRankingPerConsumers = [...(mutableResult.sort((r1, r2) => r2.uniqueUsers - r1.uniqueUsers).map(({ companyName }) => companyName ))];
      }
    });

    this.isLoading$.subscribe((data) => {
      this.loading = data;
    });
  }

  getRankClass(location: string, criteria: "impressions" | "uniqueViews" | "consumers") : number {
    switch(criteria) {
      case "impressions": {
        return rankMapping[this.locations.length][this.locationRankingPerImpression.indexOf(location)];
      }
      case "uniqueViews": {
        return rankMapping[this.locations.length][this.locationRankingPerUniqueViews.indexOf(location)];
      }
      case "consumers": {
        return rankMapping[this.locations.length][this.locationRankingPerConsumers.indexOf(location)];
      }
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
